import IrsDeclaration from './IrsDeclaration';

export default IrsDeclaration;